import ArticleBottomNavigation from './ArticleBottomNavigation'

export default ArticleBottomNavigation
